import React, { Component } from 'react';
import { Col, Form, Row, Spin } from 'antd';

import InfoBtn from '../InfoBtn/InfoBtn';
import * as customerController from '../../services/api/customer';
import './CustomerInfoBtn.scss'

const FormItem = Form.Item;

export default class CustomerInfoBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            customer: {},
            isLoading: false
        }
    }

    fetchCustomer() {
        const { customerId } = this.props;

        if (customerId) {
            this.setState({ isLoading: true });

            customerController.getCustomer(customerId)
                .then((res) => res.json())
                .then((json) => this.setState({ customer: json, isLoading: false }))
        }
    }

    handleVisibleChange(visible) {
        if (visible)
            this.fetchCustomer()
    }

    renderContent() {
        const { customer, isLoading } = this.state;
        const { name, email, contact_number, email2, contact_number2, company_name, occupation, is_locked } = customer;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        if (isLoading)
            return (<Spin/>)
        else
            return (
                <Form className="CustomerInfoForm">
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Name">
                            	<span>{name}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Email">
                            	<span>{email}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Contact Number">
                            	<span>{contact_number}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Email 2">
                                <span>{email2}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Contact Number 2">
                                <span>{contact_number2}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Company Name">
                            	<span>{company_name}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Occupation">
                            	<span>{occupation}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Is Locked">
                                <span>{is_locked ? 'Yes' : 'No'}</span>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            )
    }

    render() {
        return (
            <InfoBtn
				content={this.renderContent()}
				onVisibleChange={(visible) => this.handleVisibleChange(visible)}
			/>
        );
    }
}

CustomerInfoBtn.defaultProps = {
    customerId: ''
};


// WEBPACK FOOTER //
// ./src/components/CustomerInfoBtn/CustomerInfoBtn.js